module.exports = __webpack_public_path__ + "static/media/icon_132.184df95d.svg";